function SiteFooter() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p>&copy; 2026 Lappy Laptops. All Rights Reserved.</p>
        <div className="social-icons">
          <a
            href="https://www.instagram.com/lappylaptops/"
            target="_blank"
            rel="noreferrer"
            aria-label="Instagram"
          >
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <rect x="3" y="3" width="18" height="18" rx="5" ry="5" fill="none" stroke="currentColor" strokeWidth="2" />
              <circle cx="12" cy="12" r="4" fill="none" stroke="currentColor" strokeWidth="2" />
              <circle cx="17.5" cy="6.5" r="1.2" fill="currentColor" />
            </svg>
          </a>
          <a
            href="https://www.facebook.com/people/Lappy-Laptops/100095335695576/?ref=PROFILE_EDIT_xav_ig_profile_page_web#"
            target="_blank"
            rel="noreferrer"
            aria-label="Facebook"
          >
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M14 8h3V4h-3c-3 0-5 2-5 5v3H6v4h3v4h4v-4h3l1-4h-4V9c0-.6.4-1 1-1z" fill="currentColor" />
            </svg>
          </a>
          <a href="https://www.youtube.com/@lappy269" target="_blank" rel="noreferrer" aria-label="YouTube">
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <rect x="2" y="6" width="20" height="12" rx="3" ry="3" fill="none" stroke="currentColor" strokeWidth="2" />
              <path d="M10 9l5 3-5 3z" fill="currentColor" />
            </svg>
          </a>
        </div>
      </div>
    </footer>
  );
}

export default SiteFooter;
